import { BounakirFilterType, ConversationFilterCategory, HomeCarpetFilterCategory, HomeScreenType } from "../helpers/Enums";
import { CarpetPreviousInfo, BounakirCategorySelectionType, ConversationCategorySelectionType, HomeCarpetCategorySelectionType, HomeDataState } from "../typings/carpet";
import { MemberCarpet } from "../typings/member";
import { ConversationProps } from "../typings/messages";


export const SET_CURRENT_VIEW = 'SET_CURRENT_VIEW';
export const SET_CARPET_PREVIOUS_INFO = 'SET_CARPET_PREVIOUS_INFO';
export const SET_NEED_TO_REFRESH = 'SET_NEED_TO_REFRESH';
export const RESET_CARPET = "RESET_CARPET";

//   --------------------  HOME  --------------------
export const SET_HOME_CARPET_USERS = 'SET_HOME_CARPET_USERS';
export const ADD_HOME_CARPET_USERS = 'ADD_HOME_CARPET_USERS';
export const SET_HOME_CARPET_CATEGORY = 'SET_HOME_CARPET_CATEGORY';

//   --------------------  BOUNAKIR  --------------------
export const SET_BOUNAKIR_CARPET_USERS = 'SET_BOUNAKIR_CARPET_USERS';
export const ADD_BOUNAKIR_CARPET_USERS = 'ADD_BOUNAKIR_CARPET_USERS';
export const SET_BOUNAKIR_CARPET_CATEGORY = 'SET_BOUNAKIR_CARPET_CATEGORY';


//   --------------------  CONVERSATION  --------------------
export const SET_CONVERSATION = 'SET_CONVERSATION';
export const ADD_CONVERSATION = 'ADD_CONVERSATION';
export const SET_CONVERSATION_CATEGORY = 'SET_CONVERSATION_CATEGORY';



interface SetHomeCurrentViewTypeAction {
    type: typeof SET_CURRENT_VIEW;
    currentView: HomeScreenType;
}

interface SetCarpetPreviousInfo {
    type: typeof SET_CARPET_PREVIOUS_INFO;
    carpetPreviousInfo: CarpetPreviousInfo;
}

interface setNeedToRefreshAction {
    type: typeof SET_NEED_TO_REFRESH;
    needToRefresh: boolean
}

interface ResetCarpetAction {
    type: typeof RESET_CARPET;
}

//   --------------------  HOME_CARPET_TYPE  --------------------

interface SetHomeCarpetUsersTypeAction {
    type: typeof SET_HOME_CARPET_USERS;
    users: MemberCarpet[];
}
interface AddHomeCarpetUsersTypeAction {
    type: typeof ADD_HOME_CARPET_USERS;
    usersToAdd: MemberCarpet[];
}

interface SetHomeCarpetFilterCategoryTypeAction {
    type: typeof SET_HOME_CARPET_CATEGORY;
    carpetCategory: HomeCarpetCategorySelectionType;
}

type HomeCarpetActions = SetHomeCarpetUsersTypeAction | AddHomeCarpetUsersTypeAction | SetHomeCarpetFilterCategoryTypeAction;

//   --------------------  BOUNAKIR_CARPET_TYPE  --------------------

interface SetBounkairCarpetUsersTypeAction {
    type: typeof SET_BOUNAKIR_CARPET_USERS;
    users: MemberCarpet[];
}
interface AddBounkairCarpetUsersTypeAction {
    type: typeof ADD_BOUNAKIR_CARPET_USERS;
    usersToAdd: MemberCarpet[];
}

interface SetBounkairCarpetFilterCategoryTypeAction {
    type: typeof SET_BOUNAKIR_CARPET_CATEGORY;
    carpetCategory: BounakirCategorySelectionType;
}

type BounkairCarpetActions = SetBounkairCarpetUsersTypeAction | AddBounkairCarpetUsersTypeAction | SetBounkairCarpetFilterCategoryTypeAction;

//   -------------------- CONVERSATION_CARPET_TYPE  --------------------

interface SetConversationTypeAction {
    type: typeof SET_CONVERSATION;
    conversation: ConversationProps[];
}
interface AddConversationTypeAction {
    type: typeof ADD_CONVERSATION;
    conversationToAdd: ConversationProps;
}
interface SetConversationFilterCategoryTypeAction {
    type: typeof SET_CONVERSATION_CATEGORY;
    conversationCategory: ConversationCategorySelectionType;
}
type ConversationActions = SetConversationTypeAction | AddConversationTypeAction | SetConversationFilterCategoryTypeAction;


type HomeDataActionsTypes = HomeCarpetActions | BounkairCarpetActions | ConversationActions | SetHomeCurrentViewTypeAction | ResetCarpetAction | setNeedToRefreshAction;

//ACTIONS

export function setHomeCurrentView(currentView: HomeScreenType): HomeDataActionsTypes {
    return {
        type: SET_CURRENT_VIEW,
        currentView
    }
}

export function resetCarpet(): HomeDataActionsTypes {
    return {
        type: RESET_CARPET,
    }
}

export function setNeedToRefresh(value: boolean): HomeDataActionsTypes {
    return {
        type: SET_NEED_TO_REFRESH,
        needToRefresh: value
    }
}


// HOME_CARPET
export function setHomeCarpetFilterCategory(changeTo: HomeCarpetCategorySelectionType): HomeDataActionsTypes {
    return {
        type: SET_HOME_CARPET_CATEGORY,
        carpetCategory: changeTo
    }
}

export function setHomeCarpetUsers(users: MemberCarpet[]): HomeDataActionsTypes {
    return {
        type: SET_HOME_CARPET_USERS,
        users
    }
}

export function addHomeCarpetUsers(usersToAdd: MemberCarpet[]): HomeDataActionsTypes {
    return {
        type: ADD_HOME_CARPET_USERS,
        usersToAdd
    }
}

//BOUNKAIR
export function setBounkairCarpetFilterCategory(changeTo: BounakirCategorySelectionType): HomeDataActionsTypes {
    return {
        type: SET_BOUNAKIR_CARPET_CATEGORY,
        carpetCategory: changeTo
    }
}

export function setBounkairCarpetUsers(users: MemberCarpet[]): HomeDataActionsTypes {
    return {
        type: SET_BOUNAKIR_CARPET_USERS,
        users
    }
}

export function addBounkairCarpetUsers(usersToAdd: MemberCarpet[]): HomeDataActionsTypes {
    return {
        type: ADD_BOUNAKIR_CARPET_USERS,
        usersToAdd
    }
}

//CONVERSATION
export function setConversationCategory(changeTo: ConversationCategorySelectionType): HomeDataActionsTypes {
    return {
        type: SET_CONVERSATION_CATEGORY,
        conversationCategory: changeTo
    }
}

export function setConversation(conversation: ConversationProps[]): HomeDataActionsTypes {
    return {
        type: SET_CONVERSATION,
        conversation
    }
}

export function addConversation(conversationToAdd: ConversationProps): HomeDataActionsTypes {
    return {
        type: ADD_CONVERSATION,
        conversationToAdd
    }
}




const initialState: HomeDataState = {
    currentView: HomeScreenType.HOME,
    needToRefresh: false,
    carpetPreviousInfo: {
        scrollY: 0,
        nextPageLink: null
    },
    homeCarpetUsers: [],
    bounakirCarpetUsers: [],
    conversation: [],
    homeFilterCategory: {
        value: HomeCarpetFilterCategory.AVAILABLE_NOW,
        text: "כל החברים"
    },
    bounakirFilterCategory: {
        value: BounakirFilterType.SENT_THEM_BOUNAKIR,
        text: "הצעות היכרות  ששלחתי"
    },
    conversationFilterCategory: {
        value: ConversationFilterCategory.NONE,
        text: ''
    }
}

export default function reducer(state = initialState, action: HomeDataActionsTypes): HomeDataState {
    switch (action.type) {
        case SET_CURRENT_VIEW:
            return { ...state, currentView: action.currentView };
        case SET_HOME_CARPET_USERS:
            return { ...state, homeCarpetUsers: [...action.users] };
        case ADD_HOME_CARPET_USERS:
            return { ...state, homeCarpetUsers: [...state.homeCarpetUsers, ...action.usersToAdd] };
        case SET_HOME_CARPET_CATEGORY:
            return { ...state, homeFilterCategory: action.carpetCategory };
        case SET_BOUNAKIR_CARPET_USERS:
            return { ...state, bounakirCarpetUsers: [...action.users] };
        case ADD_BOUNAKIR_CARPET_USERS:
            return { ...state, bounakirCarpetUsers: [...state.bounakirCarpetUsers, ...action.usersToAdd] };
        case SET_BOUNAKIR_CARPET_CATEGORY:
            return { ...state, bounakirFilterCategory: action.carpetCategory };
        case SET_CONVERSATION:
            return { ...state, conversation: [...action.conversation] };
        case ADD_CONVERSATION:
            const conversation = [...state.conversation];
            let converstion = conversation.filter(x => x.memberCode === action.conversationToAdd.memberCode)[0];
            const filterdConversation1 = conversation.filter(x => x.memberCode !== action.conversationToAdd.memberCode);
            converstion.lastMessage = action.conversationToAdd.lastMessage;
            converstion.messageTypeId = action.conversationToAdd.messageTypeId;
            converstion.newMessagesCount = action.conversationToAdd.newMessagesCount;
            return { ...state, conversation: [converstion, ...filterdConversation1] };
        case SET_CONVERSATION_CATEGORY:
            return { ...state, conversationFilterCategory: action.conversationCategory };
        case RESET_CARPET:
            return { ...initialState }
        case SET_NEED_TO_REFRESH:
            return { ...state, needToRefresh: action.needToRefresh }
        default:
            return state;
    }
}